import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import RaisedButton from 'material-ui/RaisedButton';
import globals from '../../../globals/communityGlobals';
import { refSetter } from '../../../utils/helpers';
import NonPatientAddressDetails from '../Form/NonPatientAddressDetails/NonPatientAddressDetails';
import NonPatientActivityDetails from '../Form/NonPatientActivityDetails/NonPatientActivityDetails';
import NonPatientActivitySchedule from './NonPatientActivitySchedule/NonPatientActivitySchedule';
import {
  NonPatientActivityPropType,
  NonPatientActivityPropTypeDefault,
} from '../../../propTypes/entities/nonPatientActivityType';
import _ from '../../../utils/lodash';
import { getDateForApi } from '../../../utils/dates';
import AlertBox from '../../../components/common/AlertBox/AlertBox';
import Spinner from '../../../components/common/Spinner/Spinner';

const locale = globals.getArea('nonPatientActivities');

export const actionTypes = {
  edit: 'EDIT',
  create: 'CREATE',
  view: 'VIEW',
};

class NonPatientActivityForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.setStateBound = this.setState.bind(this);
    const validityDefaults = props.actionType === actionTypes.edit ? true : null;
    const mappedSelectedDate = new Date(props.selectedDate).toISOString().slice(0, 19);
    this.setStateOfNPATravelType.bind(this);
    this.state = {
      formsValidity: {
        nonPatientAddressIsValid: validityDefaults,
        nonPatientActivitySeduleIsValid: validityDefaults,
        nonPatientActivityDetailsIsValid: validityDefaults,
      },
      wholeFormErrorMessage: null,
      selectedTab: 0,
      isReset: false,
      canSave: null,
      shouldFocus: true,
      selectionNPATravelType:
        props.nonPatientActivity.address === null && props.actionType === actionTypes.edit
          ? 'npaWithoutTravel'
          : 'npaWithTravel',
      excludedClinicians: [],
      dateTo: this.getParsedDateOrNull(props.shouldAssignToday ? mappedSelectedDate : props.nonPatientActivity.dateTo),
      dateFrom: this.getParsedDateOrNull(
        props.shouldAssignToday ? mappedSelectedDate : props.nonPatientActivity.dateFrom,
      ),
      startTime: this.getParsedDateOrNull(props.nonPatientActivity.startTime),
      endTime: this.getParsedDateOrNull(props.nonPatientActivity.endTime),
    };
  }

  componentDidMount = () => {
    const data = this.props.actionType === actionTypes.create ? { retrieveOnlyActive: true } : null;
    this.props.getClinicianOptions(data);
  };

  componentWillReceiveProps = () => {
    this.setState({
      shouldFocus: true,
    });
  };

  componentDidUpdate = () => {
    const enableSave = this.canSave();

    this.setState({
      canSave: enableSave,
    });

    if (this.state.shouldFocus && this.props.failureMessage) {
      this.alertBox.focus();
      this.setState({
        shouldFocus: false,
      });
    }

    this.props.canSaveFromPlanning(enableSave);

    if (this.props.shouldAssignToday && enableSave) {
      const { recurEvery = 1 } = this.shedulerForm.getModel();

      const details = this.detailsForm.getModel();
      this.props.getNpaDetails(details);

      if (this.state.selectionNPATravelType === 'npaWithTravel') {
        const addressForm = this.addressForm.getModel();
        this.props.getNpaAddress(addressForm);
      } else {
        this.props.getNpaAddress(null);
      }

      const schedule = {
        ...this.shedulerForm.getModel(),
        dateFrom: getDateForApi(this.state.dateFrom),
        dateTo: getDateForApi(this.state.dateTo),
        recurEvery,
        startTime: getDateForApi(this.state.startTime),
        endTime: getDateForApi(this.state.endTime),
      };
      this.props.getNpaSchedule(schedule);
    }
  };

  componentWillUnmount() {
    this.props.dismissError();
  }

  onStateChange = newScheduleState => {
    this.setState({ npActivityScheduleSchedule: { ...this.state.npActivityScheduleSchedule, ...newScheduleState } });
  };

  getParsedDateOrNull = value => {
    if (value) return new Date(value);
    return null;
  };

  setRef = refSetter.bind(this);

  setValidity = formName => value => () => {
    this.setState({
      formsValidity: {
        ...this.state.formsValidity,
        [`${formName}IsValid`]: value,
      },
    });
  };

  setStateOfNPATravelType = value => {
    // eslint-disable-next-line no-unused-expressions
    value === 'npaWithTravel'
      ? this.setState({ selectionNPATravelType: value })
      : this.setState({
          selectionNPATravelType: value,
          formsValidity: { ...this.state.formsValidity, nonPatientAddressIsValid: true },
        });
  };

  setExcludedClinicians = excludedClinicians => {
    this.setState({
      excludedClinicians,
    });
  };

  handleSave = () => {
    if (this.canSave()) {
      const { saveCallback, shouldAssignToday } = this.props;
      const { selectionNPATravelType, excludedClinicians } = this.state;
      const { recurEvery = 1 } = this.shedulerForm.getModel();

      saveCallback(
        this.detailsForm.getModel(),
        selectionNPATravelType === 'npaWithTravel' ? this.addressForm.getModel() : null,
        {
          ...this.shedulerForm.getModel(),
          dateFrom: getDateForApi(this.state.dateFrom),
          dateTo: getDateForApi(this.state.dateTo),
          recurEvery,
          startTime: getDateForApi(this.state.startTime),
          endTime: getDateForApi(this.state.endTime),
        },
        shouldAssignToday,
        excludedClinicians,
      );
    } else {
      this.shedulerForm.submit();
      this.detailsForm.submit();
      this.addressForm.submit();
      this.setState({
        wholeFormErrorMessage: locale.getMsg('pleaseCompleteTabs'),
        isReset: false,
      });
    }
  };

  canSave = () => {
    const formsValidity = _.values(this.state.formsValidity);
    return formsValidity.every(el => el === true);
  };

  render() {
    const { wholeFormErrorMessage, canSave } = this.state;
    const {
      nonPatientActivity,
      failureMessage,
      dismissError,
      isAssigning,
      actionType,
      clinicianOptions,
      orgUnitId,
      shouldAssignToday,
    } = this.props;
    const mappedSelectedDate = new Date(this.props.selectedDate).toISOString().slice(0, 19);

    const mappedOrgUnit = [{ id: orgUnitId }];
    return (
      <div>
        <AlertBox
          type="notification"
          innerRef={this.setRef('alertBox')}
          content={failureMessage}
          onClick={dismissError}
        />
        {isAssigning === true ? <Spinner /> : ''}
        <Box display="flex" p={1} flexDirection="column">
          <Box p={1} flexGrow={1}>
            <NonPatientActivityDetails
              readOnly={this.state.isReset}
              innerRef={this.setRef('detailsForm')}
              setValidity={this.setValidity('nonPatientActivityDetails')}
              onStateChange={this.onStateChange}
              shouldAssignToday={shouldAssignToday}
              values={{
                notes: nonPatientActivity.notes,
                orgUnitIds: shouldAssignToday && orgUnitId != null ? mappedOrgUnit : nonPatientActivity.orgUnits,
                clinicianIds: nonPatientActivity.clinicians,
                nonPatientActivityTypeId: nonPatientActivity.nonPatientActivityTypeId,
                selectionNPATravelType: this.state.selectionNPATravelType,
                actionType,
                clinicianOptions,
                assignedTo: nonPatientActivity.assignedTo,
                assignedToIds: nonPatientActivity.assignedToIds,
              }}
              setStateOfNPATravelType={this.setStateOfNPATravelType}
              setExcludedClinicians={this.setExcludedClinicians}
            />
          </Box>
          <Box p={1}>
            <NonPatientActivitySchedule
              readOnly={this.state.isReset}
              innerRef={this.setRef('shedulerForm')}
              setValidity={this.setValidity('nonPatientActivitySedule')}
              shouldAssignToday={shouldAssignToday}
              setState={this.setStateBound}
              dateTimeValues={{
                dateFrom: this.state.dateFrom,
                dateTo: this.state.dateTo,
                startTime: this.state.startTime,
                endTime: this.state.endTime,
              }}
              defaultValues={{
                recurEvery: nonPatientActivity.recurEvery,
                recurrenceType: nonPatientActivity.recurrenceType,
                dateTo: shouldAssignToday ? mappedSelectedDate : nonPatientActivity.dateTo,
                dateFrom: shouldAssignToday ? mappedSelectedDate : nonPatientActivity.dateFrom,
                startTime: nonPatientActivity.startTime,
                endTime: nonPatientActivity.endTime,
                duration: nonPatientActivity.duration,
                selectedDays: nonPatientActivity.selectedDays,
              }}
              values={{
                recurEvery: nonPatientActivity.recurEvery,
                recurrenceType: nonPatientActivity.recurrenceType,
                dateTo: shouldAssignToday ? mappedSelectedDate : nonPatientActivity.dateTo,
                dateFrom: shouldAssignToday ? mappedSelectedDate : nonPatientActivity.dateFrom,
                startTime: nonPatientActivity.startTime,
                endTime: nonPatientActivity.endTime,
                duration: nonPatientActivity.duration,
                selectedDays: nonPatientActivity.selectedDays,
              }}
              onChange={this.onStateChange}
            />
          </Box>
          {this.state.selectionNPATravelType === 'npaWithTravel' ? (
            <Box p={1}>
              <NonPatientAddressDetails
                readOnly={this.state.isReset}
                activityAddress={nonPatientActivity.address}
                innerRef={this.setRef('addressForm')}
                setValidity={this.setValidity('nonPatientAddress')}
                actionType={actionType}
              />
            </Box>
          ) : (
            <React.Fragment />
          )}
          {!this.props.shouldAssignToday && (
            <Box p={1}>
              <RaisedButton
                type="submit"
                label={locale.getMsg('assignActivity')}
                onClick={this.handleSave}
                primary
                disabled={!canSave}
              />
              {wholeFormErrorMessage && wholeFormErrorMessage.length && (
                <span style={{ color: 'red', margin: '10px 0 0 10px' }}>{wholeFormErrorMessage}</span>
              )}
            </Box>
          )}
        </Box>
      </div>
    );
  }
}

NonPatientActivityForm.defaultProps = {
  nonPatientActivity: NonPatientActivityPropTypeDefault,
  saveCallback: () => {},
  getClinicianOptions: () => {},
  orgUnitId: null,
  selectedDate: null,
  shouldAssignToday: false,
  canSaveFromPlanning: () => {},
  getNpaDetails: () => {},
  getNpaSchedule: () => {},
  getNpaAddress: () => {},
};

NonPatientActivityForm.propTypes = {
  nonPatientActivity: NonPatientActivityPropType,
  actionType: PropTypes.string.isRequired,
  saveCallback: PropTypes.func,
  getClinicianOptions: PropTypes.func,
  failureMessage: PropTypes.string.isRequired,
  dismissError: PropTypes.func.isRequired,
  isAssigning: PropTypes.bool.isRequired,
  orgUnitId: PropTypes.number,
  selectedDate: PropTypes.date,
  shouldAssignToday: PropTypes.bool,
  canSaveFromPlanning: PropTypes.func,
  getNpaDetails: PropTypes.func,
  getNpaSchedule: PropTypes.func,
  getNpaAddress: PropTypes.func,
};

export default NonPatientActivityForm;
